import { useContext, ReactNode } from 'react';
import { AlertContext } from '~/components/LegacyAlert/LegacyAlert';

export const useModal = () => useContext( AlertContext ).showModal as ( arg0: ( onHide: () => void ) => ReactNode ) => void;
